import { AnyEnum, enumUnion, EnumValue, isValidEnumEntry } from 'aos-helpers/src/helpers/Enum'
import {
    translateEnum,
    translateEnumUnion,
} from 'aos-helpers/src/helpers/translations/Translations'
import { TFunction } from 'i18next'

export enum FilterOptionAll {
    All = 'All',
}

export type StringFilterWithAllOption = FilterOptionAll | string

export const filterOptionsWithAll = <T extends EnumValue>(
    enumEntity: AnyEnum,
): (FilterOptionAll | T)[] => enumUnion(FilterOptionAll, enumEntity)

export const optionOrAll = <T extends string>(
    value: T | FilterOptionAll,
    options: ReadonlyArray<T | FilterOptionAll>,
): T | FilterOptionAll => (options.includes(value) ? value : FilterOptionAll.All)

export const translateFilterWithAllOption =
    (t: TFunction) => (enumEntity: AnyEnum, prefix: string) =>
        translateEnumUnion(t)(prefix, FilterOptionAll, enumEntity)

export const translateStringFilterWithAllOption =
    (t: TFunction) => (prefix: string) => (value: StringFilterWithAllOption) =>
        isValidEnumEntry(FilterOptionAll)<FilterOptionAll>(value)
            ? translateEnum(t)(FilterOptionAll, prefix)(value)
            : value
